import React, { useCallback, useEffect, useRef, useState } from "react"
import { Button, Modal, ProgressBar } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import { getList, getSummary } from "../../../../controller/api/classicReturn"
import { FULL_LIST_ITEM_PER_PAGE } from "../../../../helper/helper"
import { exportTicketReturnToExcel } from "../../../../helpers/excelExport"

export default (props) => {
  const { filterData, show, onHide } = props
  const [current, setCurrent] = useState(0)
  const [total, setTotal] = useState(0)
  const [isExporting, setIsExporting] = useState(false)
  const allData = useRef([])
  const summaryData = useRef(null)

  const [cookies] = useCookies(['lottmekong'])

  const fetchTotal = useCallback(async () => {
    if (show && total === 0) {
      const response = await getList(cookies.lottmekong, filterData, 0, FULL_LIST_ITEM_PER_PAGE)
      if (response) {
        setTotal(response.total || 0)
      }
      
      const summaryRes = await getSummary(cookies.lottmekong, filterData)
      if (summaryRes && summaryRes.success) {
        summaryData.current = summaryRes.data
      }
    }
  }, [cookies.lottmekong, filterData, show, total])

  const fetchPage = useCallback(async () => {
    if (total > 0 && current * FULL_LIST_ITEM_PER_PAGE < total) {
      const response = await getList(cookies.lottmekong, filterData, current, FULL_LIST_ITEM_PER_PAGE)
      if (response && response.data) {
        allData.current = [...allData.current, ...response.data]
        setCurrent(current + 1)
      }
    }
  }, [cookies.lottmekong, filterData, current, total])

  const handleHide = useCallback(() => {
    if (!isExporting) {
      setCurrent(0)
      setTotal(0)
      allData.current = []
      summaryData.current = null
      onHide()
    } else {
      alert('Đang xuất file, vui lòng đợi...')
    }
  }, [isExporting, onHide])

  const exportFunc = useCallback(async () => {
    if (show && total > 0) {
      if (current * FULL_LIST_ITEM_PER_PAGE < total) {
        await fetchPage()
      } else {
        setIsExporting(true)
        try {
          exportTicketReturnToExcel(allData.current, summaryData.current, {
            from: filterData.from,
            to: filterData.to,
            region: filterData.region,
            reason: filterData.reason,
          })
        } finally {
          setIsExporting(false)
          handleHide()
        }
      }
    }
  }, [current, total, show, fetchPage, handleHide, filterData])

  useEffect(() => {
    fetchTotal()
  }, [fetchTotal])

  useEffect(() => {
    if (total > 0) {
      exportFunc()
    }
  }, [total, exportFunc])

  const progressValue = Math.min(current * FULL_LIST_ITEM_PER_PAGE, total)

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Đang xuất file Excel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {current === 0 && total === 0 ? 'Đang tính số trang...' : (
          <>
            <ProgressBar 
              className="progress-md" 
              variant="success" 
              now={progressValue} 
              min={0} 
              max={total} 
            />
            <div className="mt-2">
              {progressValue} / <b>{total}</b> {isExporting && '- Đang tạo file Excel...'}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleHide} disabled={isExporting}>Đóng</Button>
      </Modal.Footer>
    </Modal>
  )
}
